import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import RequireAuth from './RequireAuth';
import RequireRole from './RequireRole';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const EventsPage = Loadable(lazy(() => import('pages/events')));
const CreateEventWizardPage = Loadable(lazy(() => import('pages/events/create-wizard')));
const EventTablesPage = Loadable(lazy(() => import('pages/events/tables')));
const EventFinancePage = Loadable(lazy(() => import('pages/events/finance')));
const EventGuestsPage = Loadable(lazy(() => import('pages/events/guests')));
const EventMediaPage = Loadable(lazy(() => import('pages/events/media')));
const EventGalleryPage = Loadable(lazy(() => import('pages/events/gallery')));
const EventWishlistPage = Loadable(lazy(() => import('pages/events/wishlist')));
const PeoplePage = Loadable(lazy(() => import('pages/people')));
const UsersPage = Loadable(lazy(() => import('pages/users')));
const EmailTemplatesPage = Loadable(lazy(() => import('pages/email-templates')));
const EventTemplatesPage = Loadable(lazy(() => import('pages/event-templates')));
const ScheduledPage = Loadable(lazy(() => import('pages/scheduled')));
const AdminTransactionsPage = Loadable(lazy(() => import('pages/admin-transactions')));
const UpgradePage = Loadable(lazy(() => import('pages/upgrade')));
const UpgradeThankYouPage = Loadable(lazy(() => import('pages/upgrade/thank-you')));
const BillingHistoryPage = Loadable(lazy(() => import('pages/billing/history')));
const EditProfilePage = Loadable(lazy(() => import('pages/profile/edit')));
const ViewProfilePage = Loadable(lazy(() => import('pages/profile/view')));
const NotificationsPage = Loadable(lazy(() => import('pages/notifications')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <RequireAuth>
      <DashboardLayout />
    </RequireAuth>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'events',
      element: <EventsPage />
    },
    {
      path: 'events/wizard',
      element: <CreateEventWizardPage />
    },
    {
      path: 'events/:eventId/tables',
      element: <EventTablesPage />
    },
    {
      path: 'events/:eventId/finance',
      element: <EventFinancePage />
    },
    {
      path: 'events/:eventId/guests',
      element: <EventGuestsPage />
    },
    {
      path: 'events/:eventId/media',
      element: <EventMediaPage />
    },
    {
      path: 'events/:eventId/gallery',
      element: <EventGalleryPage />
    },
    {
      path: 'events/:eventId/wishlist',
      element: <EventWishlistPage />
    },
    {
      path: 'people',
      element: <PeoplePage />
    },
    {
      path: 'upgrade',
      element: <UpgradePage />
    },
    {
      path: 'upgrade/thank-you',
      element: <UpgradeThankYouPage />
    },
    {
      path: 'billing/history',
      element: <BillingHistoryPage />
    },
    {
      path: 'profile/edit',
      element: <EditProfilePage />
    },
    {
      path: 'profile/view',
      element: <ViewProfilePage />
    },
    {
      path: 'notifications',
      element: <NotificationsPage />
    },
    {
      path: 'admin/users',
      element: (
        <RequireRole roles={['Administrator']}>
          <UsersPage />
        </RequireRole>
      )
    },
    {
      path: 'admin/email-templates',
      element: (
        <RequireRole roles={['Administrator']}>
          <EmailTemplatesPage />
        </RequireRole>
      )
    },
    {
      path: 'admin/event-templates',
      element: (
        <RequireRole roles={['Administrator']}>
          <EventTemplatesPage />
        </RequireRole>
      )
    },
    {
      path: 'admin/scheduled',
      element: (
        <RequireRole roles={['Administrator']}>
          <ScheduledPage />
        </RequireRole>
      )
    },
    {
      path: 'admin/transactions',
      element: (
        <RequireRole roles={['Administrator']}>
          <AdminTransactionsPage />
        </RequireRole>
      )
    }
  ]
};

export default MainRoutes;
